import React from "react";
import "./Searchnav.css";
// import Navbarmenu from "./Navbarmenu";
import WelcomeName from "./WelcomeName";
function Searchnav() {
  return (
    <>
      <div role="region" aria-label="skip navigation">
        <a href="#main" class="cmp-skip-link">
          Skip to main content
        </a>
        {/* <a href="#footer" class="cmp-skip-link">Skip to footer</a> */}
      </div>
      <div class="searchnav-container">
        <div class="searchnav-wrap">
          <div class="searchnav-row row1">
            <div class="searchnav-box">
              <img
                src="images/Home/Acc_GT_Gradient_RGB-new.png"
                class="acc-logo"
                alt="Accenture logo"
                tabIndex={0}
              />
              {/* <p class="desktop-tag" tabIndex={0}>
                <span>Learning & Talent Transformation</span>
              </p>
              <p class="mobile-tag">
                <span>L&TT</span>
              </p> */}
            </div>
          </div>
          <div class="searchnav-row row2">
            <div class="searchnav-box">{/* <Navbarmenu /> */}</div>
          </div>
          <div class="searchnav-row row3">
            <div class="searchnav-box">
              {/* <p>Hello {localStorage.getItem("empName")}!</p> */}
              {/* <p>Hello !</p> */}
              <WelcomeName />
              <img
                src="images/Avatar-new.png"
                class="user-img"
                alt="user-image"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Searchnav;
